// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Button } from 'antd';
import { useDashboard } from '@Hooks/useDashboard';
import { DashboardDropRowResult, WIDGET_DND_TYPES } from '@Types';
import { addElementOnArray } from '@Helpers/';
import DraggableElement from '@Atoms/DraggableElement/DraggableElement';
import { ICONS } from '@Constants/iconsApp';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';

export const RowCreate = (): ReactElement => {
    const { setRows, dashboard } = useDashboard();

    const rows = dashboard?.definition.items || [];

    const createNewRow = (dropResult: DashboardDropRowResult) => {
        const { hoveredRowIndex } = dropResult || {};
        const newRow = { type: 'container', items: [] };
        setRows(addElementOnArray(rows, newRow, hoveredRowIndex));
    };

    return (
        <DraggableElement onDragFinish={createNewRow} dragType={WIDGET_DND_TYPES.ROW}>
            <THTooltip title={'Row'} placement="bottom">
                <Button icon={<ICONS.InsertRowAboveOutlined />} size="large" shape="circle" />
            </THTooltip>
        </DraggableElement>
    );
};
